import AppStorage from '@/utils/helpers';
import React, { useEffect, useState } from 'react';
import logo from '@/assets/logo@2x.png';
import ng from '@/assets/nigeria_flag.png';
import Image from 'next/image';

type BillingInformationProps = {
  onSubmit: (phoneNumber: string, fullName: string) => Promise<void>;
  title?: string;
};

const BillingInformation: React.FC<BillingInformationProps> = ({
  onSubmit,
  title,
}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [fullName, setFullName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    await onSubmit(phoneNumber, fullName);
    setLoading(false);
  };

  // useEffect(() => {
  //   const email = AppStorage.get('email');
  //   if (email) {
  //     setPhoneNumber(email);
  //   }
  // }, []);
  const buttonName = title === 'Register/Login' ? 'Sign in' : 'Begin Checkout';
  return (
    <div className="w-full flex flex-col gap-12">
      <h3 className="text-base sm:text-lg font-medium text-left leading-6 whitespace-nowrap text-[#475569]">
        Fill in appropriate details to continue
      </h3>
      <div className="w-full flex items-center justify-center">
        <Image src={logo} alt="crnchies_logo" priority className='w-20 h-20' />
      </div>
      <div className="flex flex-col gap-8">
        <div>
          <label
            htmlFor="name"
            className="text-[#475569] text-base font-medium mb-1"
          >
            Your full name
          </label>
          <input
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            placeholder="Enter your full name"
            className="w-full p-2 border rounded"
          />
        </div>

        <div>
          <label
            htmlFor="name"
            className="text-[#475569] text-base font-medium mb-1"
          >
            Phone number
          </label>
          <div className="flex items-center gap-1">
            <span className="py-3 px-4 flex items-center border gap-2 rounded-lg">
              +234 <Image src={ng} alt="NG" className='w-4 h-4 mr-2' />
            </span>
            <input
              type="tel"
              value={phoneNumber}
              min='10'
              max='11'
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Your phone number"
              className="w-full py-3 px-4 border rounded-lg"
            />
          </div>
        </div>

        <button
          onClick={handleSubmit}
          className="w-full bg-red-500 text-white py-4 px-6 rounded-lg"
          disabled={loading}
        >
          {loading ? 'Submitting...' : buttonName}
        </button>
      </div>
    </div>
  );
};

export default BillingInformation;
